<template>
  <b-container
    class="py-5 mb-5 mt-5 d-flex justify-content-center custom-container"
  >
    <change-email-form v-if="currentRoute === 'email'" />
    <change-phone-form v-else-if="currentRoute === 'phone_number'" />
    <change-password-form v-else-if="currentRoute === 'password'" />
    <delete-account-form v-else-if="currentRoute === 'account'" />
  </b-container>
</template>

<script>
import ChangeEmailForm from '@/components/forms/ChangeEmailForm'
import ChangePhoneForm from '@/components/forms/ChangePhoneForm'
import ChangePasswordForm from '@/components/forms/ChangePasswordForm'
import DeleteAccountForm from '@/components/forms/DeleteAccountForm'

export default {
  components: {
    ChangeEmailForm,
    ChangePhoneForm,
    ChangePasswordForm,
    DeleteAccountForm,
  },

  computed: {
    currentRoute() {
      return this.$route.params.field
    },
  },

  created() {
    if (!this.$route.params.field) {
      this.$router.replace({
        name: 'user.settings-page',
        hash: '#account',
      })
    }
  },
}
</script>
